const expiryDateEST = new Date("2025-11-02T11:59:00-05:00"); // EST = UTC-5
console.log("🗓 Deadline (EST):", expiryDateEST.toString());
function getESTNow() {
  const now = new Date();
  const estString = now.toLocaleString("en-US", { timeZone: "America/New_York" });
  return new Date(estString);
}

const daysEl = document.querySelector(".days");
const hoursEl = document.querySelector(".hours");
const minutesEl = document.querySelector(".minutes");
const secondsEl = document.querySelector(".seconds");
const expiredEl = document.getElementById("expired");

function updateCountdown() {
  const nowEST = getESTNow();
  const diff = expiryDateEST - nowEST;

  console.clear();
  

  // If time has expired
  if (diff <= 0) {
    // Set all to 00
    daysEl.textContent = "00";
    hoursEl.textContent = "00";
    minutesEl.textContent = "00";
    secondsEl.textContent = "00";

    // Show expired message
    if (expiredEl) expiredEl.textContent = "⏰ Expired!";

    // console.log("🔥 Countdown expired — set all to 00.");
    clearInterval(timer);
    return;
  }

  const totalSeconds = Math.floor(diff / 1000);
  const days = Math.floor(totalSeconds / (60 * 60 * 24));
  const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  daysEl.textContent = String(days).padStart(2, "0");
  hoursEl.textContent = String(hours).padStart(2, "0");
  minutesEl.textContent = String(minutes).padStart(2, "0");
  secondsEl.textContent = String(seconds).padStart(2, "0");

  // console.log(`⏳ Remaining: ${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`);
}

updateCountdown();
const timer = setInterval(updateCountdown, 1000);
